import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

export const defaultState = {
	docketReportFilters: {
		partyDropdownSelectedValues: [],
		partyFilterIds: [],
		partyDropdownSearchValue: "",

		courtDropdownSelectedValues: [],
		courtDropdownSearchValue: "",

		districtCourtDropdownSelectedValues: [],
		districtCourtDropdownSearchValue: "",

		judgeDropdownSelectedValues: [],
		judgeDropdownSearchValue: "",

		selectedANDA: 0,
		apiANDAIds: [],
	},
};

const DOCKET_REPORT_UPDATE_FILTERS = (state, action) => {
	const { filters } = action;
	return {
		...state,
		docketReportFilters: filters,
	};
};

const handlers = {};
handlers[actionTypes.DOCKET_REPORT_UPDATE_FILTERS] = DOCKET_REPORT_UPDATE_FILTERS;
export default createReducer(defaultState, handlers);
